import { t } from '@lingui/core/macro';
import { Box, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function EmptyGridReadonly() {
    return (<Box flexDirection="column" justifyContent="center">
      <EmptyState withAvatar icon={<Falcon icon="chart-line-up"/>} title={t({
            message: 'No widgets',
            comment: 'Insights: Title for when no widgets has been added to dashboard',
        })} description={t({
            message: 'No widgets has been added to this dashboard yet.',
            comment: 'Insights: Description for when no widgets has been added to dashboard',
        })}/>
    </Box>);
}
